<template>
  <div class="contact">
    <template v-for="(item,index) in contactList">
      <div :class="['contact-li', 'contact-'+item.value]"  :key="index" v-if="item.show" @click="clickTab(item.value)">
        <img :src="item.img" alt="">
      </div>
    </template>
    <div v-if="maskStatus" class="mask-bg" @click="maskStatus = !maskStatus">
      <img src="@/assets/weichat.jpg" alt="">
    </div>
    <div class="phone-content" v-if="phoneStatus">
      <div class="header">
        <span>电话咨询</span>
        <img @click="phoneStatus = !phoneStatus" src="@/assets/white-close.png" alt="">
      </div>
      <div class="add-phone">
        <!-- <div class="phone-top">
          <img src="@/assets/contact-fixed-4.png" alt="">
          <span>您的手机号</span>
        </div> -->
        <div class="phone-top"><img src="@/assets/contact-fixed-4.png" alt="">（内地）：+86 18911057086</div>
        <div class="phone-top">
          <img src="@/assets/contact-fixed-4.png" alt="">（香港）：+852 67559270
          <!-- <span>您的手机号</span> -->
        </div>
        <!-- <el-input v-model="phone" placeholder="请输入">
          <template #append><span @click="savePhone">提交</span></template>
        </el-input> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios  from 'axios'
import CryptoJS from 'crypto-js'
export default {
  data() {
    return {
      contactList: [
        {img: require('@/assets/contact-fixed-1.png'), value: 1, show: true},
        {img: require('@/assets/contact-fixed-2.png'), value: 2, show: true},
        {img: require('@/assets/contact-fixed-3.png'), value: 3, show: true},
        {img: require('@/assets/contact-fixed-3.png'), value: 4, show: false}
      ],
      maskStatus: false,
      phoneStatus: false,
      phone:''
    }
  },
  methods: {
    clickTab(value) {
      if(value == 3 || value == 4) {
        this.contactList.map(item=>{
          item.show = !item.show
        })
      }
      if(value == 1) {
        this.maskStatus = !this.maskStatus
      }
      if(value == 2) {
        this.phone = ''
        this.phoneStatus = !this.phoneStatus
      }
    },
    savePhone() {
      let chineseMobileRegex = /^1[3-9]\d{9}$/
      if(!chineseMobileRegex.test(this.phone)) {
        return this.$message.error("请输入正确的手机号码")
      }
      let that = this
      axios({
          method: 'post',
          url: 'https://borunfuture.cn:8080/api/bo/config/save',
          data: {
            'type': 'phone',
            content: this.phone
          },
          headers: {
              'sign': CryptoJS.MD5('borun'+new Date().getTime()).toString(),
              'Content-Type': 'application/json'
          }
      })
      .then(function (response) {
          that.phone = ''
          that.phoneStatus = false
          that.$message.success('提交成功')
      })
      .catch(function (error) {
          
      });
    }
  }
}
</script>

<style>
.van-collapse-item__title--expanded:after{
  display: none!important;
}
.el-timeline-item__node--normal {
  background: blue;
}
</style>
<style lang="scss" scoped>
.contact {
  position: fixed;
  top: calc((100vh - 162Px) / 2);
  right: 0;
  z-index: 100;
  .contact-li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54Px;
    height: 54Px;
    background: #fff;
    border: 2Px solid rgba(230, 230, 230, 1);
    border-right: none;
    border-bottom: none;
    cursor: pointer;
    img {
      width: 14Px;
    }
  }
  .contact-1 {
    img {
      width: 21Px;
    }
  }
  .contact-3 {
    border-bottom: 2Px solid rgba(230, 230, 230, 1);
  }
  .contact-4 {
    border-bottom: 2Px solid rgba(230, 230, 230, 1);
    transform: rotateX(180deg);
  }
  .mask-bg {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 110;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0,0.6);
    img {
      // width: 220Px;
      height: 234Px;
      background: #fff;
      padding-left: 5Px;
    }
  }
  .phone-content {
    position: fixed;
    top: calc((100vh - 300Px) / 2);
    right: 0;
    z-index: 100;
    width: 210Px;
    height: 136Px;
    background: #fff;
    box-shadow: 0px 2px 7px  rgba(0, 0, 0, 0.21);
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 52Px;
      padding: 0 16Px;
      font-size: 14Px;
      line-height: 20Px;
      color: #fff;
      background: rgba(176, 152, 80, 1);
      img {
        width: 10Px;
        height: 10Px;
        cursor: pointer;
      }
    }
    .add-phone {
      height: 58Px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 12Px 0;
      .el-input {
        width: 140Px;
        height: 24Px;
        margin: 0 auto;
        border-radius: 12Px;
        background: rgba(244, 244, 244, 1);
      }
      ::v-deep {
        .el-input__wrapper {
          font-size: 12Px;
          border-radius: 12Px 0 0 12Px;
          border: none;
          background: rgba(244, 244, 244, 1);
          box-shadow: none;
        }
        .el-input-group__append {
          width: 40Px;
          font-size: 12Px;
          padding: 0 8Px;
          border-radius: 12Px;
          background: rgba(176, 152, 80, 1);
          box-shadow: none;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    .phone-top {
      display: flex;
      align-items: center;
      padding: 0 16Px;
      font-size: 12Px;
      line-height: 24Px;
      color: rgba(102, 102, 102, 1);
      img {
        width: 10Px;
        // margin-right: 6Px;
      }
    }
  }
}
@include h5() {
  .contact {
    .contact-li {
      width: 64px;
      height: 64px;
      border: 2px solid rgba(230, 230, 230, 1);
      border-bottom: none;
      border-right: none;
      img {
        width: 11Px;
      }
    }
    .contact-1 {
      img {
        width: 18Px;
      }
    }
    .contact-3 {
      border-bottom: 2px solid rgba(230, 230, 230, 1);
    }
    .contact-4 {
      border-bottom: 2px solid rgba(230, 230, 230, 1);
      transform: rotateX(180deg);
    }
  }
}
</style>